import { render, staticRenderFns } from "./TutoringManage.vue?vue&type=template&id=67c28cc4"
import script from "./TutoringManage.vue?vue&type=script&lang=ts"
export * from "./TutoringManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports